import styled from 'styled-components'

export const BaseButton = styled.button`
  outline-color: #002d63;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  font-weight: bold;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
  cursor: pointer;
`

export const PageTitle = styled.h1`
  font-weight: bold;
  font-size: 28px;
`
